<template>
  <div class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>客户报表</span>
      </div>
      <div v-for="(item,index) in customer_menu" :key="index">
        <el-link type="primary" @click="setMenu(item)">{{ item.name }}</el-link>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CustomerMain",
  inject:['ReportCustomer'],
  data(){
    return{
      customer_menu:[
        {name:"客户信息明细表",components:"CustomerList"},
        {name:"客户房产信息表",components:"CustomerHouse"},
        {name:"房产费项表",components:"CustomerHouseChange"},
        {name:"入伙信息明细表",components:"HouseMoveInfo"},
        {name:"装修信息明细表",components:"FitmentList"},
        {name:"项目房态占比统计",components:"HouseRoomStatus"},
        {name:"项目房态费项占比统计",components:"HouseRoomStatusMoney"},
        // {name:"房态变动统计表",components:""},
        // {name:"房态统计表",components:""},
      ],
    }
  },
  methods:{
    setMenu(item){
      this.ReportCustomer.customerMenuIndex=item.components
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  padding: 10px 10px;
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 45%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/CustomerMain.vue